var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 245,
    viewBox: "0 0 207 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_772_20238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7155_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1925_2_",
    d: "M104.451 183.617V180.016H117.602H130.753V183.617V187.217H117.602H104.451V183.617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1923_2_",
    d: "M104.451 195.375V191.804H117.572H130.693V195.375V198.946H117.572H104.451V195.375Z",
    fill: "#30E700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1921_2_",
    d: "M175.75 195.375V180.019L179.654 180.021L183.558 180.023L191.252 189.615L198.946 199.207L198.961 189.613L198.976 180.019H202.894H206.813V195.375V210.731L202.879 210.729L198.946 210.726L191.252 201.135L183.558 191.543L183.543 201.137L183.528 210.731H179.641H175.752L175.75 195.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1919_2_",
    d: "M104.451 207.133V203.532H117.602H130.753V207.133V210.734H117.602H104.451V207.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1917_2_",
    d: "M74.1446 195.375V180.019H78.0336H81.9226V191.777V203.535H90.4277H98.9327V207.136V210.736H86.5362H74.1396V195.375H74.1446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1913_2_",
    d: "M36.4184 210.66C36.4726 210.515 46.0645 181.078 46.2272 180.553L46.3948 180.016C50.5228 179.996 54.6509 180.009 58.779 180.019L63.7573 195.316C65.7905 201.549 67.5477 206.956 68.3216 209.349C68.499 209.817 68.6247 210.271 68.7874 210.729C68.6494 210.729 67.8706 210.731 64.6026 210.731H60.4622L59.3581 207.234L58.254 203.737L52.593 203.722L46.932 203.708L45.8255 207.207L44.7189 210.707L40.5563 210.722C37.2317 210.729 36.3962 210.719 36.4184 210.66ZM55.8561 196.664C55.8561 196.622 55.3582 195.062 54.7495 193.194C54.1408 191.328 53.4063 189.071 53.118 188.181L52.5906 186.562L50.9443 191.607C50.0373 194.382 49.298 196.671 49.2955 196.696C49.2955 196.721 50.7718 196.74 52.5758 196.74C55.2449 196.74 55.8561 196.726 55.8561 196.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1911_2_",
    d: "M0 195.375V180.019H3.88901H7.77802L7.79281 185.896L7.8076 191.774L15.5141 191.789L23.2207 191.804V185.911V180.019H27.1393H31.0579V195.375V210.731H27.1393H23.2207V204.839V198.946L15.5141 198.961L7.8076 198.976L7.79281 204.853L7.77802 210.731H3.88901H0V195.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path854_2_",
    d: "M152.15 211.451C148.803 211.237 145.587 210.096 142.947 208.186C139.369 205.593 137.104 201.933 136.411 197.63C136.268 196.74 136.236 194.675 136.35 193.704C136.574 191.789 137.02 190.256 137.843 188.583C139.973 184.253 144.009 181.041 148.85 179.824C151.516 179.154 154.429 179.114 157.113 179.708C164.056 181.246 169.256 186.769 170.089 193.492C170.193 194.332 170.207 196.245 170.116 197.078C169.811 199.851 168.766 202.441 166.996 204.812C166.4 205.61 164.864 207.17 164.083 207.774C163.164 208.481 162.19 209.09 161.123 209.622C159.257 210.554 157.49 211.086 155.433 211.343C154.71 211.431 152.82 211.495 152.15 211.451ZM154.733 204.425C158.543 203.789 161.495 200.878 162.264 197.002C162.424 196.193 162.407 194.421 162.232 193.605C161.818 191.676 160.946 190.106 159.541 188.753C158.55 187.799 157.441 187.129 156.132 186.695C154.913 186.291 153.813 186.148 152.586 186.239C148.418 186.545 145.104 189.482 144.216 193.665C144.042 194.485 144.029 196.139 144.189 196.974C144.431 198.229 144.926 199.441 145.626 200.499C146.178 201.329 147.272 202.428 148.086 202.968C150.102 204.306 152.413 204.812 154.733 204.425Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.2596 243.7H38.4697L32.2796 236H32.0597V243.7H28.1396V222.84H34.3797C39.3597 222.84 42.2996 225.3 42.2996 229.42C42.2996 232.19 40.7296 234.96 36.5296 235.78L43.2596 243.7ZM34.1396 232.92C36.9696 232.92 38.3396 231.66 38.3396 229.64C38.3396 227.6 36.8296 226.42 34.2796 226.42H32.0696V232.92H34.1396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.5801 222.84H61.1501V226.4H52.5001V231.47H60.4201V234.77H52.5001V240.15H61.1501V243.71H48.5801V222.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.59 228.19H80.56L75.8 243.7H71.68L65.46 222.84H69.46L73.83 238.86H73.89L78.71 222.84H82.41L87.31 238.88H87.34L91.57 222.84H95.49L89.39 243.7H85.39L80.59 228.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M113.46 243.7L111.42 238.21H103.24L101.22 243.7H97.1299L105.05 222.84H109.56L117.57 243.7H113.46ZM104.36 234.91H110.27L107.3 226.99L104.36 234.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M137.54 243.7H132.75L126.56 236H126.34V243.7H122.42V222.84H128.66C133.64 222.84 136.58 225.3 136.58 229.42C136.58 232.19 135.01 234.96 130.81 235.78L137.54 243.7ZM128.41 232.92C131.24 232.92 132.61 231.66 132.61 229.64C132.61 227.6 131.1 226.42 128.55 226.42H126.34V232.92H128.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M159.939 233.26C159.939 239.56 155.349 243.7 148.659 243.7H142.859V222.84H148.659C155.429 222.84 159.939 226.99 159.939 233.26ZM146.779 240.09H148.819C153.019 240.09 155.929 237.63 155.929 233.29C155.929 228.89 153.019 226.43 148.849 226.43H146.779V240.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M177.47 223.8V227.5C176.07 226.49 174.08 225.9 172.37 225.9C170.44 225.9 168.95 226.74 168.95 228.28C168.95 229.71 170.21 230.38 172.62 231.39C175.64 232.65 178.67 233.97 178.67 237.77C178.67 241.63 175.59 244.15 171.25 244.15C168.7 244.15 166.43 243.25 165.06 242.25V238.3C166.52 239.67 168.76 240.65 170.91 240.65C173.04 240.65 174.63 239.61 174.63 237.91C174.63 236.34 173.15 235.59 170.68 234.52C167.94 233.37 165.05 232.03 165.05 228.44C165.05 224.8 167.96 222.39 172.16 222.39C174.25 222.4 176.12 222.98 177.47 223.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M83.5401 110.11L71.0801 97.66L87.4501 81.29H25.6201V134.33C25.6201 146.01 35.1801 155.57 46.8601 155.57H99.9001V93.74L83.5401 110.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M159.95 0H106.91V61.83L123.28 45.46L135.73 57.91L119.36 74.28H181.19V21.24C181.19 9.56 171.63 0 159.95 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M135.73 97.66L123.28 110.11L106.91 93.74V155.57H159.95C171.63 155.57 181.19 146.01 181.19 134.33V81.29H119.36L135.73 97.66Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M99.9001 61.83V0H46.8601C35.1801 0 25.6201 9.56 25.6201 21.24V74.28H87.4501L71.0801 57.92L83.5301 45.47L99.9001 61.83ZM40.1401 8.9H40.1801C40.4001 12.33 43.2401 15.05 46.7301 15.05C43.1001 15.05 40.1601 17.99 40.1601 21.62C40.1601 17.99 37.2201 15.05 33.5901 15.05C37.0701 15.05 39.9201 12.33 40.1401 8.9ZM49.9201 56.15C49.9201 49.27 44.3401 43.69 37.4601 43.69C44.0701 43.69 49.4601 38.54 49.8801 32.03H49.9601C50.3701 38.54 55.7701 43.69 62.3801 43.69C55.5001 43.69 49.9201 49.27 49.9201 56.15ZM62.9001 30.51C62.9001 27.75 60.6701 25.52 57.9101 25.52C60.5601 25.52 62.7201 23.46 62.8801 20.85H62.9101C63.0801 23.46 65.2401 25.52 67.8801 25.52C65.1301 25.52 62.9001 27.76 62.9001 30.51Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.6201 62.97H99.9001L103.95 69.59L106.91 62.97H181.19V92.6H108.3L103.95 89.06L99.1001 92.6H25.6201V62.97Z",
    fill: "#30E700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M83.5331 45.4652L71.0811 57.9172L123.272 110.108L135.724 97.6563L83.5331 45.4652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M123.272 45.4654L71.0811 97.6565L83.5331 110.109L135.724 57.9175L123.272 45.4654Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_772_20238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.81,
    height: 244.15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.47eef4ca0eacfbc7e329b47bac29f281.svg";
export { ForwardRef as ReactComponent };